<template>
   <Forms ref="frmSearch"
           :title="report === 2 ? 'Busca por PIVS' : report === 1 ? 'Buscar por PIT' : 'Buscar por LV' "
           :showHelp="true"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClearSection"
           v-on:Search="Search"
           style="font-family: 'Segoe UI'"
           >
            <div style="width: 100%;">
              <label class="labelsearch">Código {{ report === 2 ? 'PIVS' : report === 1 ? 'PIT' : 'LV' }}</label>
              <b-input v-model="form.Apr" :placeholder="'Informe o código ' +  (report === 0 ? 'LV' : report === 1 ? 'PIT' : 'PIVS')" />
            </div>
            <div class="margem" style="width: 100%;">
              <label class="labelsearch">Código da Obra</label>
                <autocomplete-z ref="obraRHTypeahead"
                    placeholder="Digite o nome da Obra"
                    iconClass="fas fa-hard-hat"
                    :serializer="(obra) => obra.referencia"
                    :debounceLength="1"
                    :formField="form.obraid"
                    v-on:search="onSearchObra"
                    :ShowCode="false"
                    v-on:changeCode="onChangeCodeObra"/>
            </div>
            <div style="width: 100%;" class="margem">
              <label class="labelsearch">Atividade</label>
              <select v-model="form.AtividadeId" class="form-control">
                <option :value="null" disabled>Selecione</option>
                <option v-for="data in dataAtividade" :key="data.id" :value="data.id">{{data.descricao}}</option>
              </select>
            </div>

              <div class="labelsearch mt-3" for="txtInsured">Desde</div>
              <div class="margem-buton d-flex align-items-end">
                <b-form-datepicker
                  v-model="form.InicioDataSolicitacao"
                  ref="dataInicio"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
              <label class="labelsearch mt-3" for="txtInsured">Até</label>
              <div class="d-flex align-items-end">
                  <b-form-datepicker
                  v-model="form.FimDataSolicitacao"
                  ref="dataFim"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
   </Forms>
</template>

<script>
import qmaReportFiltro from './qmaReportFiltro'
export default qmaReportFiltro
</script>

<style scoped>
.labelsearch{
  font-weight: 700;
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0;
  font-family: Segoe UI;
}
.margem-buton{
  margin-bottom: 0.5rem;
}

.margem{
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaReport/components/qmaReportTable/components/qmaReportFiltro/qmaReportFiltro.vue